import script from "./ReportUser.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportUser.vue?vue&type=script&setup=true&lang=js"

import "./ReportUser.vue?vue&type=style&index=0&id=2f8643f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f8643f1"]])

export default __exports__